module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    class: [_vm.icon],
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.tip) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v("(" + _vm._s(_vm.tip) + ")")]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ca7b802", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ca7b802!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/icon-title.vue
// module id = 753
// module chunks = 0